import { Stack, FieldErrors } from "@certn/cascadia-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import { Switch } from "../components/Switch";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function ToggleControl(props: CascadiaControlProps) {
  const { options, description, path, testID } = props;
  const { t } = useTranslation();
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);

  if (isSummaryForPath?.(path)) {
    return (
      <SummaryItem label={props.label}>
        {props.data ? t("Yes") : t("No")}
      </SummaryItem>
    );
  }

  return (
    <Stack gap="space-1">
      <Switch
        id={props.id}
        isSelected={props.data}
        onChange={props.setValue}
        isDisabled={!props.enabled}
        helpText={description}
        isReadOnly={!props.enabled}
        card={options.card}
        onBlur={props.setTouched}
        testID={testID}
      >
        {props.label}
      </Switch>
      {props.touched && <FieldErrors>{props.errors}</FieldErrors>}
    </Stack>
  );
}

ToggleControl.displayName = "ToggleControl";

export const ToggleControlRenderer = withCascadiaControlProps(ToggleControl);
